import { logEvent } from './logGaEvent'

export const logPricePrediction = ({ recommendations = [] }) => {
  if (recommendations.length === 0 || recommendations[0]?.recommendation === 'NO_RECO') {
    logPricePredictionNoRec()
    return
  }

  logPricePredictionDisplay({ recommendations })
}

const logPricePredictionDisplay = ({ recommendations }) => {
  const { recommendation } = recommendations[0]

  const recommendationMap = {
    BUY: 'buy_now',
    WAIT: 'wait',
  }

  logEvent('display', {
    type: 'price_prediction',
    item_name: recommendationMap[recommendation],
    screen_name: 'listings',
    product_name: 'air',
  })
}

const logPricePredictionNoRec = () => {
  logEvent('api_call', {
    type: 'price_prediction_no_rec',
    screen_name: 'listings',
    product_name: 'air',
  })
}

export const logPricePredictionError = () => {
  logEvent('api_call', {
    type: 'price_prediction_null',
    screen_name: 'listings',
    product_name: 'air',
  })
}
